<template>
  <div class="flex-b-c">
    
      <div class="flex-ac" :class="$style.left">
        <span :class="$style.label">工号</span>
        <el-input v-model.trim="username" placeholder="请输入工号" style="width: 120px; margin-right: 5px;" @input="onChange"></el-input>
        <span :class="$style.err_msg" v-if="errMsg">{{ errMsg }}</span>
      </div>

      <div class="flex-ac">
        <span :class="$style.label">计划数</span>
        <el-input-number
          v-model="times_set"
          :min="0"
          :step="1"
          stepStrictly
          :controls="false"
          style="width: 80px;margin-right: 20px;"
        ></el-input-number>
      </div>
      <div class="flex-ac" :class="$style.right">
        <span :class="$style.label">定制分组</span>
        <el-select v-model="group_id" multiple placeholder=" " size="mini" collapse-tags>
          <el-option
            v-for="item in groupOptions"
            :key="item.id"
            :label="item.realname"
            :value="item.id">
          {{ `${item.realname}-${item.username}-${item.times_set}` }}
          </el-option>
        </el-select>
        <el-button class="ml30" size="mini" @click="onSubmit" :loading="loading">保存</el-button>
        <el-button size="mini" @click="$emit('cancel')">取消</el-button>
      </div>
  </div>
</template>

<script>
import { listNameAdd } from './api'
export default {
  props: {
    queue_id: [Number, String],
    list: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return  {
      username: undefined,
      times_set: undefined,
      group_id: [],
      errMsg: '',
      groupOptions: [],
      loading: false,
    }
  },
  watch: {
    list: {
      handler(value) {
        this.groupOptions = value?.filter(item => item.is_open === 1)
        this.group_id = this.group_id?.filter(id => {
          let tar = value?.find(item => item.id === id)
          return tar?.is_open === 1 
        })
      },
      deep: true,
      immediate: false
    },
  },
  mounted() {
    this.group_id = this.list?.filter(item => item.customized_grouping === 1 && item.is_open === 1)?.map(item => item.id) || []
    this.groupOptions = this.list?.filter(item => item.is_open === 1)
  },
  methods: {
    async onSubmit () {
      if (!this.username) {
        this.$message.error('请输入工号')
        return
      }
      if (!this.times_set) {
        this.$message.error('请输入计划数')
        return
      }
      try {
        this.loading = true
        let { code, msg } = await listNameAdd({
          times_set: this.times_set,
          queue_id: this.queue_id,
          username: this.username,
          group_id: this.group_id?.length ? this.group_id : undefined
        })
        if (code !== 200) {
          this.errMsg = msg
        } else {
          this.errMsg = ''
          this.$emit('update')
        }
      } finally {
        this.loading = false
      }
    },
    onChange () {
      this.errMsg = ''
    }
  }
}
</script>

<style lang='scss' module>
.label {
  flex-shrink: 0;
  margin-right: 5px;
}
.err_msg {
  color: #cf0000;
  text-align: left;
}
.left {
  min-width: 230px;
}
.right {
  width: 40%;
}
</style>